export default __webpack_public_path__ + "static/media/gray-vaccine-2.be071f07.svg";